import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from '@lightspeed/flame/Button';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import { Divider } from '@lightspeed/flame/Divider';
import Group from '@lightspeed/cirrus-group';
import { IconPrinters } from '@lightspeed/flame/Icon/Printers';
import { IconExport } from '@lightspeed/flame/Icon/Export';
import Table from 'cirrus/Table';

import Pager from 'pages/containers/Pager';
import TableSorter from 'pages/containers/TableSorter';
import SearchBar from 'pages/containers/SearchBar';

import { entities } from 'pages/store/schema';
import { getData } from 'pages/store/actions/data';
import { actionTypes } from 'pages/store/actions/defaults';
import { getValues, getProcessing, getMeta, getLinks } from 'pages/store/selectors';

import { paths as brandsPaths } from '../routes';

const pageSize = { 'page[size]': 50 };

class BrandsListing extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.dataInit && !nextProps.isLoading) {
      return {
        dataInit: true,
      };
    }

    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      dataInit: false,
    };
  }

  componentDidMount() {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            type: 'ui_tab',
            text: 'Inventory',
            name: 'inventory',
          },
          {
            text: 'Brands',
          },
        ],
      },
    });

    this.props.getData(`/admin/brands${this.props.location.search}`, { params: { ...pageSize } });
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.search !== prevProps.location.search) {
      this.props.getData(`/admin/brands${location.search}`, { params: { ...pageSize } });
    }
  }

  getTableHead() {
    return {
      cells: [
        {
          key: 'brand',
          content: (
            <TableSorter {...{ sortKey: 'brand.name', entity: entities.brand }}>Brand</TableSorter>
          ),
        },
        {
          key: 'items',
          content: (
            <TableSorter {...{ sortKey: 'brand.items_count', entity: entities.brand }}>
              Items
            </TableSorter>
          ),
          align: 'right',
          width: '10rem',
        },
      ],
    };
  }

  getTableBody() {
    const { brands } = this.props;
    return map(brands, brand => ({
      key: brand.id,
      hover: true,
      cells: [
        {
          content: (
            <Link
              to={{ pathname: brandsPaths.details.replace(':id', brand.id) }}
              key={brand.id}
              className="listing__link notranslate"
            >
              <span className="cr-bold">{get(brand, 'attributes.name', 'Invalid name')}</span>
            </Link>
          ),
        },
        { content: <span className="cr-gray">{get(brand, 'attributes.items_count', 0)}</span> },
      ],
    }));
  }

  render() {
    const { meta, links, isLoading } = this.props;
    const { dataInit } = this.state;
    const { pagination } = meta;

    return (
      <div className="cirrus react-page__listing" data-test="brands-listing">
        <div className="cr-flex cr-width-full cr-justify-between cr-mb-2 no_print">
          <Group noSpacing>
            <Button onClick={() => window.print()} data-test="brands-listing-print-button">
              <IconPrinters /> Print
            </Button>
            <Button
              className="cr-button-link griffin-no-display"
              href={links ? links.export : ''}
              disabled={links ? !links.export : true}
              data-test="brands-listing-export-button"
            >
              <IconExport /> Export
            </Button>
          </Group>
          <Link
            to={{
              pathname: brandsPaths.new,
            }}
          >
            <Button variant="primary" fill data-test="new-brand">
              + New Brand
            </Button>
          </Link>
        </div>
        <Card>
          <CardSection noSpacing>
            <div className="listing__filters cr-flex cr-width-full cr-justify-between cr-ph-3 cr-pv-2 no_print">
              <SearchBar />
              <Pager {...{ pagination }} />
            </div>
            <Divider />
          </CardSection>
          <CardSection noSpacing>
            <Table
              head={this.getTableHead()}
              body={this.getTableBody()}
              isLoading={isLoading}
              dataInit={dataInit}
              noDataMessage="No brands were found."
            />
          </CardSection>
        </Card>
      </div>
    );
  }
}

BrandsListing.defaultProps = {
  isLoading: true,
};

BrandsListing.propTypes = {
  isLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
  brands: getValues(entities.brand)(state),
  meta: getMeta({ entity: entities.brand, list: true })(state),
  links: getLinks({ entity: entities.brand, list: true })(state),
  isLoading: getProcessing({ entity: entities.brand, list: true, actionType: actionTypes.LOADING })(
    state
  ),
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  getData: (url, options, onSuccess) =>
    dispatch(getData({ url, entity: entities.brand, list: true, options, onSuccess })),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandsListing);
